<template>
    <div>

        <div class="col-xs-12 col-sm-6" v-bind:style="{'height':'250px','background-size': '100% auto'}">

            <div>
                <div>


                    <div class="agx-post-intros">
                        <div style="z-index:999;text-align:right;" v-if="item.category!==null">
                            <div class="label label-primary" style="z-index:999;display:inline-block;">{{item.parentCategory.name}} </div> /
                            <div class="label label-info" style="z-index:999;display:inline-block;"> {{item.category.name}} </div>
                        </div>
                        <h3>
                            <router-link :to="{name:'detail',query:{postId:item.postId,scode:item.shopCode}}">
                                {{item.title}}
                            </router-link>
                        </h3>
                        <div style="white-space:pre-line;height:40px;" v-if="item.textMsg!==null && item.textMsg!==''">
                            {{item.textMsg}}
                        </div>
                    </div>
                    <div class="agx-trans-layer"></div>
                    <div class="col-xs-4 col-md-4">
                        <router-link :to="{name:'detail',query:{postId:item.postId,scode:item.shopCode}}">
                            <img style="display:inline-block;height:200px;border-bottom-left-radius:10px;border-bottom-right-radius:10px;"
                                 class="agx-post-thumb" :src="item.thumbPath" :title="item.title">
                        </router-link>
                    </div>

                </div>
            </div>
        </div>


        <div class="col-xs-12 col-sm-6" v-bind:style="{'background':'url('+item.thumbPath+')','height':'250px','background-size': '100% auto'}">

            <div>
                <div>
                    <div class="agx-trans-layer"></div>
                    <div class="col-xs-12 col-md-12">
                        <div style="height:40px;">
                            
                        </div>
                        <div>
                            <div class="col-xs-12" v-for="link in item.links">
                                <div class="col-xs-4" style="text-align:right;">
                                    <a :href="link.linkUrl"> <img style="width:50px;height:50px;margin:4px;" :src="link.imgThumb" /></a>
                                </div>
                                <div class="col-xs-8">
                                    <a :href="link.linkUrl"><span style="font-weight:bold;font-size:1.5em;">{{link.linkTitle}}</span></a>
                                    <div>{{link.linkText}}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>





    </div>
</template>
<script>

    export default {
        components: {

        },
        filters: {
            fPrice: function (priceArr) {
                if (typeof (priceArr) !== "undefined" && priceArr !== null && priceArr.length > 0) {
                    var priceLow = null;
                    var priceUp = null;
                    var priceText = "";
                    var priceCount = priceArr.length;
                    if (priceCount > 0) {
                        priceLow = priceArr[0];
                    }

                    if (priceCount - 1 > 0) {
                        priceUp = priceArr[priceCount - 1];
                    }

                    if (priceLow !== null) {
                        priceText = priceLow.price;
                    }

                    if (priceUp !== null) {
                        priceText += " -- ";
                        priceText += priceUp.price;
                    }
                    return priceText;
                }
                return "";
            }
        },
        props: ["item", "itemType"],
        data: function () {
            return {

            }
        },
        mounted: function () {

        }
    }
</script>